import { CookieOutlined, InfoOutlined } from '@mui/icons-material';
import { Box, BoxProps, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { LogoNegative } from '../../main-app/components/Logo';
import { useCookieConsentControl } from '../../main-app/modules/cookie-consent/useCookieConsent';
import { getConfig } from '../../main-app/utils/config';

const { landingPageUrl, registerUrl } = getConfig();

export const Footer = (props: BoxProps) => {
  const { show } = useCookieConsentControl();
  return (
    <Box bgcolor={'secondary.light'} {...props}>
      <Container
        sx={{
          display: 'flex',
          gap: { xs: 2, sm: 4 },
          flexDirection: 'column',
          pt: 4,
          pb: 2,
          color: 'white',
        }}
      >
        <Box display={'flex'} gap={{ xs: 2, sm: 4 }} flexDirection={{ xs: 'column', sm: 'row' }}>
          <Box flex={1}>
            <Typography variant={'h3'}>
              {'Jsme'}
              <LogoNegative
                height={24}
                width={undefined}
                style={{ position: 'relative', top: 6, marginLeft: '0.5rem' }}
              />
            </Typography>
            <Typography whiteSpace={'break-spaces'} mt={3}>
              {'Česká aplikace, která za vás odešle upomínky za nezaplacené faktury.\n' +
                'S aplikací Upomínej můžete mít klidnější spánek a více se věnovat tomu, co vás skutečně baví.\n\n' +
                'Nabízíme možnosti sledování splatnosti faktur a jiných pohledávek.\nPo registraci za vás budeme upomínat (e-mail, sms, telefonát) pohledávky, kterým se blíží splatnost a zvýšíme tak šanci získání peněz do termínu splatnosti.'}
            </Typography>
          </Box>
          <Box flex={1}>
            <Typography variant={'h3'}>{'Proč to s námi funguje?'}</Typography>
            <ul>
              <li>
                <Typography>{'progresivní systém eskalovaného upomínání'}</Typography>
              </li>
              <li>
                <Typography>{'volba důraznosti tónu upomínání'}</Typography>
              </li>
              <li>
                <Typography>{'profesionálně vyškolené operátorky'}</Typography>
              </li>
              <li>
                <Typography>{'integrace nejpoužívanějšího účetního nástroje POHODA'}</Typography>
              </li>
              <li>
                <Typography>{'technická podpora na nejvyšší úrovni'}</Typography>
              </li>
              <li>
                <Typography>{'možnost slevy pro firemní zákazníky'}</Typography>
              </li>
              <li>
                <Typography>{'moderní a plně responsivní aplikace'}</Typography>
              </li>
            </ul>
            <Button component={Link} to={registerUrl} variant={'outlined'} color={'inherit'} target={'_blank'}>
              Registrovat
            </Button>
          </Box>
        </Box>
        <Box
          flex={1}
          display={'flex'}
          justifyContent={'space-between'}
          gap={2}
          flexWrap={'wrap'}
          alignItems={'baseline'}
        >
          <Button
            component={Link}
            to={landingPageUrl}
            target={'_blank'}
            size={'small'}
            color={'inherit'}
            startIcon={<InfoOutlined />}
            aria-label={'cookies consent control'}
          >
            více info na upominej.cz
          </Button>
          <Typography variant={'caption'}>{`© ${new Date().getFullYear()} Upomínej s.r.o.`}</Typography>
          <Button
            size={'small'}
            color={'inherit'}
            startIcon={<CookieOutlined />}
            onClick={show}
            aria-label={'cookies consent control'}
          >
            nastavení cookies
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
